import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MktTaggingTransformationService } from 'src/app/core/services';
import { getBrowserNameForTagging } from '../../utility/browser-util';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-save',
  templateUrl: './citi-shop-save.component.html',
  styleUrls: ['./citi-shop-save.component.scss'],
  standalone: false
})
export class CitiShopSaveComponent implements OnInit {
  saveSection;
  @Input() contentSave: any = '{}';
  @Output() ctabuttonClicked = new EventEmitter<boolean>();

  constructor(
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    public csp: CitiShopPropsService
    ){}

  ngOnInit(): void {
    this.saveSection = this.contentSave;
  }

  onSaveSectionLinkClick(btnName: string, sectionName: string) {
    this._viewAllCardsTagging(btnName, sectionName)
  }

  private _viewAllCardsTagging(btnName: string, sectionName: string) {
    const tagObj = {
      'link_name': `${sectionName}|${btnName}`,
      'form_type': getBrowserNameForTagging(),
    }
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing_ctaclicked', tagObj)
  }

  buttonClicked(event) {
    this.ctabuttonClicked.emit(event);
  }

}
